import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import sncfLogo from '../../assets/SNCF.png';

interface SidebarProps {
  onShowValidationLogs?: () => void;
  onShowGOF?: () => void;
  onShowStats?: () => void;
  onShowFilters?: () => void;
  onNewIntervention?: () => void;
  onSendEmail?: () => void;
  onShowLineManagement?: () => void;
  pendingCount?: number;
  lineManagementCount?: number;
}

// ===== Composant Sidebar =====
const Sidebar: React.FC<SidebarProps> = ({
  onShowValidationLogs,
  onShowGOF,
  onShowStats,
  onShowFilters,
  onNewIntervention,
  onSendEmail,
  onShowLineManagement,
  pendingCount = 0,
  lineManagementCount = 0
}) => {
  const { user, logout } = useAuth();

// ===== Composant SidebarButton =====
  const SidebarButton: React.FC<{
    icon: string;
    label: string;
    onClick?: () => void;
    gradient?: string;
    color?: string;
    badge?: number;
    id: string;
  }> = ({ icon, label, onClick, gradient, color = '#4f46e5', badge, id }) => {
    return (
      <button
        onClick={onClick}
        className="sidebar-item-button"
      >
        <div
          className="sidebar-button-icon-box"
          style={{
            background: gradient || color,
          }}
        >
          <i className={`fas ${icon}`}></i>
          {(badge !== undefined && badge !== null && badge > 0) && (
            <span className="sidebar-badge-ios">
              {badge > 99 ? '99+' : badge}
            </span>
          )}
        </div>
        <span className="sidebar-label">{label}</span>
      </button>
    );
  };

  return (
    <aside className="sidebar">
      {/* Logo */}
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <img src={sncfLogo} alt="SNCF" />
        </div>
        <div className="sidebar-title">Suivi LGV</div>
      </div>

      {/* Navigation principale */}
      <nav className="sidebar-nav">
        <div className="sidebar-section">
          {/* 1. Nouvelle Intervention (Pas pour les technicentres) */}
          {user?.role !== 'technicentre' && (
            <SidebarButton
              id="new"
              icon="fa-plus"
              label="Nouvelle intervention"
              onClick={onNewIntervention}
              gradient="linear-gradient(180deg, #34C759 0%, #28A745 100%)"
            />
          )}

          {/* 2. Envoyer Email (GOF uniquement) */}
          {user?.isGOF && (
            <SidebarButton
              id="email"
              icon="fa-envelope"
              label="Envoyer Email"
              onClick={onSendEmail}
              gradient="linear-gradient(180deg, #5AC8FA 0%, #30B0C7 100%)"
            />
          )}

          {/* 3. Gestion des Lignes (GOF uniquement) */}
          {user?.isGOF && (
            <SidebarButton
              id="linemanagement"
              icon="fa-tasks"
              label="Gestion des lignes"
              onClick={onShowLineManagement}
              gradient="linear-gradient(180deg, #FF9500 0%, #D77D00 100%)"
              badge={lineManagementCount}
            />
          )}

          {/* 4. Filtres */}
          <SidebarButton
            id="filters"
            icon="fa-filter"
            label="Filtres"
            onClick={onShowFilters}
            gradient="linear-gradient(180deg, #007AFF 0%, #0051D5 100%)"
          />

          {/* 5. Statistiques (Pas pour les technicentres) */}
          {user?.role !== 'technicentre' && (
            <SidebarButton
              id="stats"
              icon="fa-chart-pie"
              label="Statistiques"
              onClick={onShowStats}
              gradient="linear-gradient(180deg, #5856D6 0%, #4138C2 100%)"
            />
          )}

          {/* 6. Historique (tous utilisateurs) */}
          <SidebarButton
            id="history"
            icon="fa-history"
            label="Historique"
            onClick={onShowValidationLogs}
            gradient="linear-gradient(180deg, #AF52DE 0%, #8B44CC 100%)"
            badge={user?.isGOF ? undefined : pendingCount}
          />

          {/* 7. Paramètres (Pas pour les technicentres) */}
          {user?.role !== 'technicentre' && (
            <SidebarButton
              id="params"
              icon="fa-cogs"
              label="Paramètres"
              onClick={onShowGOF}
              gradient="linear-gradient(180deg, #FF3B30 0%, #D70015 100%)"
            />
          )}

          {/* 8. Déconnexion */}
          <SidebarButton
            id="logout"
            icon="fa-sign-out-alt"
            label="Déconnexion"
            onClick={logout}
            gradient="linear-gradient(180deg, #8E8E93 0%, #636366 100%)"
          />
        </div>
      </nav>
    </aside>
  );
};

export default Sidebar;

